export default "__VITE_ASSET__hmRRZ_wX__"